export interface MenuItem {
  title: string
  link: string
  iconUrl: string
}

export const migrantMenu: MenuItem[] = [
  {
    title: 'profile',
    link: '/profile',
    iconUrl: '/icons/icon-user.svg'
  },
  // {
  //   title: 'notifications',
  //   link: '/notifications',
  //   iconUrl: '/icons/icon-bell.svg'
  // },
  {
    title: 'recipients',
    link: '/contacts',
    iconUrl: '/icons/icon-users.svg'
  },
  {
    title: 'orders',
    link: '/orders',
    iconUrl: '/icons/icon-credit-card.svg'
  }
  // {
  //   title: 'payments',
  //   link: '/payments',
  //   iconUrl: '/icons/icon-credit-card.svg'
  // },
  // {
  //   title: 'language',
  //   link: '/onboarding/language',
  //   iconUrl: '/icons/icon-globe.svg'
  // },
  // {
  //   title: 'change country',
  //   link: '/shop/selectDestination',
  //   iconUrl: '/icons/icon-crosshair.svg'
  // }
]

export const vendorMenu: MenuItem[] = [
  {
    title: 'dashboard',
    link: '/vendor',
    iconUrl: '/icons/icon-user.svg'
  },
  {
    title: 'listings',
    link: '/vendor/listings',
    iconUrl: '/icons/icon-user.svg'
  },
  {
    title: 'orders',
    link: '/vendor/orders',
    iconUrl: '/icons/icon-cart.svg'
  },
  {
    title: 'gifts',
    link: '/vendor/gifts',
    iconUrl: '/icons/icon-gift.svg'
  }
]
